import * as actionTypes from '../actionTypes';

export const playPause = (value) => {
  return {
    type: actionTypes.PLAY_PAUSE,
    playingAudio: value,
  };
};
